import { reactive, ref, computed, watch } from '@vue/composition-api'
import store from '@/store'
import * as apiQA from '@/api/qa'

/**
 * 裁判所検索ウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    search_text: '', // 検索キーワード

    list: [], // 一覧表示用リスト
    listAll: [], // 全件リスト

    court_name: '', // 裁判所名（データバインディング用）

    selectedCourtName: '', // 選択した裁判所名

    /**
     * データロード発動
     * startLoading=trueになった時にloadData()メソッドを実行する
     */
    startLoading: watch(() => {
      if (props.startLoading) {
        group1.loadData()
      }
    }),

    /**
     * 表示用データをロードする
     */
    loadData: () => {

      // 裁判所一覧取得APIをコール
      const params = {}

      apiQA.listCourts(params)
        .then(response => {
          if (response) {
            const { data } = response

            group1.list = data.lists
            group1.listAll = data.lists

            // 親ウィンドウ表示用で保持している裁判所を本ウィンドウの変数に設定
            // 裁判所名（データバインディング用）
            group1.court_name = context.parent.group1.judgement.court_names[0] ?? ''
            // 選択した裁判所名
            group1.selectedCourtName = context.parent.group1.judgement.court_names[0] ?? ''
        
          }
        })

    },

    /**
     * キーワード検索
     */
    search: () => {

      if (store.state.common.device === 'sp') {
        // キーワード入力欄のフォーカス表示フラグをfalseに設定
        state.isFocusedInput = false
      }

      let newList = []
      if (group1.search_text === '') {
        // 検索キーワード未入力の場合
        newList = group1.listAll
      } else {
        // 検索キーワードを入力している場合
        for (let i = 0; i < group1.listAll.length; i++) {
          const name = group1.listAll[i].name
          if (name.indexOf(group1.search_text) >= 0) {
            newList.push(group1.listAll[i])
          }
        }
  
      }
      group1.list = newList
    },

    /**
     * 選択項目が変わった場合
     */
    onSelectedItemsChanged: () => {

      // group1.court_nameはキーワード検索されたリスト内での選択された裁判所名であり、
      // 全裁判所内で選択した裁判所でははいので、
      // group1.court_nameとgroup1.selectedCourtNameは同じとは限らない。

      // ラジオボタン（択一選択）なので、そのまま設定
      group1.selectedCourtName = group1.court_name
    },

    /**
     * 決定ボタンを押した場合
     */
    submit: () => {
      
      // 親ウィンドウのデータ用の裁判所名を設定
      const courtNames = []
      if (group1.selectedCourtName !== '') {
        courtNames.push(group1.selectedCourtName)
      }
      context.emit('updateCourtNames', courtNames)

      context.emit('closeSearchDetailCourtList')
    }

  })

  const state = reactive({
    isOpenHistoryTags: false, // SP用
    isFocusedInput: false, // SP用
    isSearchTextInput: false // 検索テキスト入力フラグ // SP用
  })

  return {
    group1,
    state
  }
}
